import { useState, useEffect, useRef } from "react";
import { CustomProperty } from "winslow-core";
import { selectUser } from "../../../redux/features/appData";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { toastFail, toastSuccess } from "../../../config";
import { postMultipleFileUpload } from "../../../services/client"
import "./AppCustomPropertyFile.css";


const ACCEPTABLE_FILE_TYPES =
  "application/pdf, " +
  "application/msword, " +
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document, " +
  "text/plain, " +
  "text/html";

const MAX_FILE_UPLOAD_SIZE = 20485760;

type AppCustomPropertyFileProps = {
    customProperty: CustomProperty;
    data: any;
    validate: boolean;
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyFile = ({customProperty, data, validate, onChange} : AppCustomPropertyFileProps) => {

    const storeUser = useSelector(selectUser)

    const [uploadFiles, setUploadFiles] = useState<FileList | null>(null);
    const uploadFileRef = useRef(null);

    const handleFileChange = (event: any) => {
        if (!storeUser) {
          return;
        }
    
        if (event.target.files && event.target.files?.length < 1) {
          return;
        }

        // make sure they are not too big
        for (let i = 0; i < event.target.files.length; i++) {
          if (event.target.files[i].size > MAX_FILE_UPLOAD_SIZE) {
            toast("File is too big! Please keep it under 20MB", toastFail);
            return;
          }
        }
    
        const filesArray = uploadFiles ? Array.from(uploadFiles) : [];
        if (event.target.files) {
          const newFiles = [
            ...Array.from(event.target.files),
            ...filesArray,
          ] as File[];
          const dataTransfer = new DataTransfer();
          newFiles.forEach((file: File) => dataTransfer.items.add(file as File));
          
          // const newFileList = [...uploadFiles]
          // setUploadFiles(upload)
          setUploadFiles(dataTransfer.files);
          onChange(customProperty.label, dataTransfer.files);
        }
    };
    

    const handleOpenSystemFilePicker = () => {
        if (uploadFileRef?.current) {
          const inputButton = uploadFileRef.current as any;
          inputButton.click();
        }
    };

    const settings = JSON.parse(customProperty.settings || "{}");

    // console.log("[AddCustomPropertyFile] uploadFiles: ", uploadFiles);

    return (
        <div className="app-custom-property-file">
            {/* <div className="app-custom-property-label">
                {customProperty.label}
            </div> */}
            <div className="app-custom-property-value">
               
                <button
                  className="button-save"
                  onClick={() => {
                            handleOpenSystemFilePicker();
                          }}
                >
                  {settings.allowMultiple ? "Upload Files" : "Upload"}
                </button>
                {uploadFiles && uploadFiles.length > 0 && 
                  Array.from(uploadFiles).map((file: File) => {
                      return (
                        <div
                          key={file.name}
                          className="app-custom-property-file-item"
                        >
                          {file.name}
                        </div>
                      )
                    })
                }
                                  
                <div className="app-custom-property-file-select">
                    <input
                      type="file"
                      multiple={true}
                      accept={ACCEPTABLE_FILE_TYPES}
                      onChange={handleFileChange}
                      onError={(event) => console.log("onError", event)}
                      ref={uploadFileRef}
                      title="Upload Files"
                    />
                  </div>
            </div>
        </div>
    )
}
